import { render, staticRenderFns } from "./ReviewResultModal.vue?vue&type=template&id=64e0425d&scoped=true"
import script from "./ReviewResultModal.vue?vue&type=script&lang=js"
export * from "./ReviewResultModal.vue?vue&type=script&lang=js"
import style0 from "./ReviewResultModal.vue?vue&type=style&index=0&id=64e0425d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64e0425d",
  null
  
)

export default component.exports